import React from 'react';
import Helmet from 'react-helmet';
import { HTMLHeadProps } from './HTMLHead.types';
import { generateFaqJsonLd } from '../../utils/LTSUtils';

const HTMLHead = (props: HTMLHeadProps) => {
  const { data, hasFaq, blockSearchEngineIndexing } = props;
  const {
    pageUrl,
    template: { meta_title = '', meta_description = '', meta_keywords = '', sample_url = '' }
  } = data;

  const faqJsonLd = hasFaq ? generateFaqJsonLd() : {};

  return (
    <Helmet>
      <title>{meta_title}</title>
      <meta name="description" content={meta_description} />
      <meta name="keywords" content={meta_keywords} />
      <link rel="canonical" href={pageUrl || sample_url} />
      {blockSearchEngineIndexing && <meta name="robots" content="noindex" />}
      {blockSearchEngineIndexing && <meta name="googlebot" content="noindex" />}
      {hasFaq && <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>}
    </Helmet>
  );
};

export default HTMLHead;
